module.exports = __webpack_public_path__ + "static/img/fructose.10cbdda2.jpg";